<template>
<div class="box-style">

      <van-nav-bar placeholder title="评分" left-text="" left-arrow @click-left="onClickLeft()">
      </van-nav-bar>

      <div class="yj-box">
        <div class="box-title">
          <h2>课程信息</h2>
        </div>
        <div class="yj-con">
          <div class="con-list"><span>机构名称：</span><p>{{ data.institutionName }}</p></div>
          <div class="con-list"><span>课程名称：</span><p>{{ data.curriculumName  }}</p></div>
          <div class="con-list"><span>上课时间：</span><p>{{ data.classTime }}</p></div>
          <div class="con-list"><span>总课时：</span><p>{{ data.classHour }}</p></div>
          <div class="con-list"><span>报名价格：</span><p>￥{{ data.price }}</p></div>
          <div class="con-list"><span>任课老师：</span><p><em>{{ data.teacherName }}</em></p></div>
          <div class="con-list"><span>上课地点：</span><p>{{ data.address }}</p></div>
          <div class="con-list"><span>开班日期：</span><p>{{ data.startDate }}</p></div>
          <div class="con-list"><span>课程简介：</span><p>{{ data.introduction }}</p></div>
          <div class="con-list"><span>学员姓名：</span><p><em>{{ data.studentName }}</em></p></div>
          <div class="con-list"><span>名额：</span><p>{{ data.leftHour }}</p></div>
          <div class="con-list" v-if="data.pic"><span>图片：</span><p><img v-for="(e,i) in data.pic.split(',')" :key="i" :src="fileDisplayPrefix +  e" /></p></div>
          <div class="con-list">评分：<van-rate v-model="data.starNum" allow-half void-icon="star"/></div>
        </div>
        <div class="jg-bottom">
          <van-button class="jg-but" type="info" @click="submit()">提交</van-button>
        </div>
      </div>
</div>
</template>

<script>
import {getUnpaidDetailById, save} from "../../api/course/course";
import {FILE_DISPLAY_PREFIX} from "../../api/upload";

export default {
name: "unpaid",
  data(){
   return{
     data:{},
     fileDisplayPrefix:FILE_DISPLAY_PREFIX

   }
  },
  created() {
    this.data.id = this.$route.query.id
    getUnpaidDetailById(this.$route.query.id).then(res =>{
      if (res.code === 10000){
        this.data = res.result
      }
    })

  },
  methods:{
    submit(){
      const data={
        curriculumId : this.data.curriculumId,
        starNum : this.data.starNum

      }
      save(data).then(res =>{
        if (res.code === 10000){
          this.$toast("评价成功！")
         this.onClickLeft()
        }
      })
      console.log(data)
    },

    onClickLeft(){
      this.$router.push({path: `/course`})
    },

    getReturnPremium(res){
      this.$router.push({path: `/course/returnPremium?id=${res.id}`})
    }

  }
}
</script>

<style scoped>
.yj-box{
  display: flex;
  margin: 0 10px;
  flex-direction: column;
}
.box-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height:16px;
  margin-top: 23px;
  margin-bottom: 17px;
}
.box-title h2{
  display: flex;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
.box-title img{
  width: 16px;
  height: 9px;
}
.yj-con{
  background: #ffffff;
  border-radius:12px;
  display: flex;
  padding: 17px;
  flex-direction: column;
}
.yj-con h1{
  font-size:16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 20px;
}
.con-list{
  display: flex;
  margin-bottom: 15px;
  align-items: center;
}
.con-list:last-child{
  margin-bottom: 0;
}
.con-list span{
  display: flex;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #777777;
  width:75px;
  justify-content: flex-end;
  padding-right: 5px;
}
.con-list p{
  display: flex;
  flex: 1;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.con-list p img{
  height: 15vw;
  width:73px;
  margin-right: 5px;
}
.con-list p em{
  display: flex;
  height:28px;
  background: #FFFFFF;
  border-radius:14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  padding: 8px 10px;
  margin-right: 5px;
}
/deep/.van-uploader__preview-image{
  height: 15vw;
  width:73px;
}
.box-style{
  padding-bottom: 20px;
  background:#f2f6fd;
  min-height: 100vh;
}
.jg-bottom{
  border-top: none;
}
.jg-bottom .jg-but{
  display: flex;
  padding: 0 3px;
  background:#66C779;
  border-radius: 25px;
  width: 100%;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: none;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}
</style>
